import { 
  CLIENT_STATS_AND_EVENTS_API_LOADING,
  SAVE_CLIENT_STATS__AND_EVENTS_GRAPH,
  CLIENT_SESSION_AND_AFFINITY_API_LOADING,
  CLIENT_SESSION_AND_AFFINITY_API_SUCCESS,
  CLIENT_EVENT_AND_STATS_API_LOADING,
	CLIENT_EVENT_AND_STATS_API_SUCCESS,
	CLIENT_EVENT_AND_STATS_API_ERROR
 } from "../../constants/graphConstants/connectedClientsGraphConstants";

 export const clientStatsAndEventGraphReducer = (
   state = { 
    loading : false,
    events : [],
    clientInfo : {},
    clientStats : [],
    clientSessionAffinity : {
      loading : false,
      clientInfo: {},
      clientSessions: []
    },
    clientEventAndStats : {
      loading : false,
      clientInfo : {},
      clientStats : [],
      events : [],
      error : null
    }
   }
   ,action
  ) => {
    switch (action.type) {
        case CLIENT_STATS_AND_EVENTS_API_LOADING:
          return {
            ...state,
            events : [],
            clientInfo : {},
            clientStats : [],
            loading: action.payload,
          };
        case SAVE_CLIENT_STATS__AND_EVENTS_GRAPH:
          return {
            ...state,
            loading: false,
            ...action.payload,
          };
        case CLIENT_SESSION_AND_AFFINITY_API_LOADING:
          return {
            ...state,
            clientSessionAffinity : {
              loading : true,
              clientInfo: {},
              clientSessions: []
            },
          };
        case CLIENT_SESSION_AND_AFFINITY_API_SUCCESS:
          return {
            ...state,
            clientSessionAffinity : {
              loading : false,
              ...action.payload
            },
          };
        case CLIENT_EVENT_AND_STATS_API_LOADING:
          return {
            ...state,
             clientEventAndStats : {
              loading : action.payload,
              clientInfo : {},
              clientStats : [],
              events : [],
              error : null
            }
          };
        case CLIENT_EVENT_AND_STATS_API_SUCCESS:
          return {
            ...state,
             clientEventAndStats : {
              loading : false,
              error: null,
              ...action.payload
            }
          };
        case CLIENT_EVENT_AND_STATS_API_ERROR:
          return {
            ...state,
             clientEventAndStats : {
              ...state.clientEventAndStats,
              loading : false,
              error: action.payload,
              clientStats : [],
              events : [],
            }
          };
        default:
          return state;
      }
}